import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'

@Component
export default class ReferredItem extends Vue {
  @Prop({ default: '' }) referred!: String
  @Prop({ default: '' }) amount!: String
  @Prop({ default: '' }) date!: String

  get getDate () {
    const date = new Date()
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
  }
}
